import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MiniTable from '../LazyWidgets/MiniTable';
import Modal from '../LazyWidgets/Modal';
import Pagination from '../LazyWidgets/Pagination';
import s from './LearningObjectives.module.css';
import MLIcon from '../MLIcon';
import { GREY_TEXT } from '../../src/ReportsTabs/reports-constants';

class ResponsiveLearningObjectives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      learningObjectiveData: props.learningObjectiveData || [],
      paginatedActivePage: props.paginatedActivePage || 1,
      lOPaginatedData: props.lOPaginatedData || [],
    };
    this.getCard = this.getCard.bind(this);
    this.paginate = this.paginate.bind(this);
    this.miniTableColumns = this.miniTableColumns.bind(this);
    this.elementRef = React.createRef();
    this.adjustDropdowns = this.adjustDropDowns.bind(this);
  }

  componentDidUpdate() {
    this.adjustDropDowns();
  }

  getCard() {
    const {
      getCircleTextElement,
      getTableData,
      pageSize,
      primaryAccessor,
    } = this.props;
    const {
      learningObjectiveData,
      paginatedActivePage,
      lOPaginatedData,
    } = this.state;

    return (
      <div className={s.qqLOBodyContainer}>
        <div className={s.qqAccordionTableHeader} aria-hidden>Objective Title</div>
        <div>
          {lOPaginatedData.map((row, i) => {
            const tableData = getTableData(row, primaryAccessor);
            return (
              <div className={s.qqResponsiveAccordionTitle} key={`asignment-${row.id}-${i}`}>
                <Modal
                  className={s.qqModalResponsive}
                  trigger={
                    <div>
                      <MLIcon
                        type="folder"
                        role="presentation"
                        width="18px"
                        height="18px"
                        color={GREY_TEXT}
                        className={s.qqAccordionFolderIcon}
                      />
                      <div className={s.qqAccordionTitleName}>
                        {row.name}
                      </div>
                      <div className={s.qqAccordionSubextContainer}>
                        {getCircleTextElement(row, tableData.data.length, s.qqAccordionSubTextInModal, primaryAccessor)}
                      </div>
                    </div>
                  }
                >
                  <Modal.Header>
                    <p className={s.qqLOTitle}>Learning Objective</p>
                  </Modal.Header>
                  <Modal.Content className={s.qqModalResponsiveContent}>
                    <div ref={this.elementRef}>
                      <div className={s.qqAccordionModalTitleName}>
                        {row.name}
                      </div>
                      <div className={s.qqSubtextContainer}>
                        {getCircleTextElement(row, tableData.data.length, s.qqAccordionSubTextInModal, primaryAccessor)}
                      </div>
                      <MiniTable
                        className={s.qqMiniTable}
                        data={tableData.data}
                        columns={this.miniTableColumns()}
                        styling={tableData.lOTableStyle}
                        ruled
                        autosort={false}
                        onColumnChange={this.adjustDropdowns}
                        minWidth={304}
                      />
                    </div>
                  </Modal.Content>
                </Modal>
              </div>
            );
          })
          }
        </div>
        {(learningObjectiveData.length > pageSize) &&
          <Pagination
            className={s.qqLOPagination}
            activePage={paginatedActivePage}
            boundaryRange={10}
            onPageChange={this.paginate}
            totalPages={Math.ceil(learningObjectiveData.length / pageSize)}
            siblingRange={0}
            firstItem={null}
            lastItem={null}
          />}
      </div>
    );
  }

  miniTableColumns() {
    const cft = _.find(this.props.tableColumns, ['accessor', this.props.primaryAccessor.accessor]);
    const mini = [...this.props.tableColumns];
    const indexToRemove = mini.indexOf(cft);
    mini.splice(indexToRemove, 1);
    mini.splice(1, 0, cft);
    return mini;
  }

  paginate(e, obj) {
    const start = (obj.activePage - 1) * this.props.pageSize;
    const end = start + this.props.pageSize;
    this.setState({
      lOPaginatedData: this.state.learningObjectiveData.slice(start, end),
      paginatedActivePage: obj.activePage,
    });
  }

  adjustDropDowns() {
    if (this.elementRef.current) {
      const dropDowns = this.elementRef.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const fakeWidth = this.calculateFakeWidth(dropDown.options[dropDown.selectedIndex].textContent);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(s.ellipsis);
        } else {
          dropDown.parentElement.classList.remove(s.ellipsis);
        }
      }
    }
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  render() {
    return (
      <div className={s.qqLOCardContainer}>
        {this.getCard()}
      </div>
    );
  }
}

ResponsiveLearningObjectives.propTypes = {
  learningObjectiveData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  lOPaginatedData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  pageSize: PropTypes.number,
  paginatedActivePage: PropTypes.number,
  getTableData: PropTypes.func,
  getCircleTextElement: PropTypes.func,
  tableColumns: PropTypes.array,
  primaryAccessor: PropTypes.object,
};

export default (ResponsiveLearningObjectives);
